export default __webpack_public_path__ + "static/media/calendar.44e527de.gif";